// Far Reaches (Pluto): stars near the edge of the sky score more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const farReaches: AlignmentDef = {
  id: 'far-reaches',
  planet: 'pluto',
  name: 'Far Reaches',
  text: () => `Stars near the edge of the sky score +${N.farReachesPercent}%.`,
  starPercent: (star, _c, ctx) => {
    const { x, y } = star.node;
    const e = N.farReachesEdge;
    return x <= e || y <= e || x >= ctx.sky.width - e || y >= ctx.sky.height - e ? N.farReachesPercent : 0;
  },
};
